import React from 'react';
import PropTypes from 'prop-types';

import VideoBrowseHeader from './videoBrowseHeader';
import VideoBrowseContent from './videoBrowseContent';

const VideosBrowse = ({
  browse,
  isLoading,
  onButtonGroupChanged = () => {},
  onLoadMore = () => {},
  view = 'tile',
}) => (
  <div>
    <VideoBrowseHeader onButtonGroupChanged={onButtonGroupChanged} view={view} />
    <VideoBrowseContent
      browse={browse}
      onLoadMore={onLoadMore}
      view={view}
      isLoading={isLoading}
      hasMore={false}
    />
  </div>
);

VideosBrowse.propTypes = {
  browse: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onButtonGroupChanged: PropTypes.func,
  view: PropTypes.string,
  onLoadMore: PropTypes.func,
};

export default React.memo(VideosBrowse);
